import get from './get';
import post from './post';
export default { get, post };
